import React from 'react'
import styled from 'styled-components'

import { Box } from '@usap/uicomponents'

export const Container = styled(Box)`
  width: 100%;
`

export const SubHeading = styled(Box)`
  flex-direction: row;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: column;
  }
`

export const LiveChat = styled.button`
  color: #2E6B9E;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
`

export const Spacer = styled(Box)`
  width: 100%;
  align-items: center;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    alignn-items: flex-end;
    width: 50%;
  }
`
